import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const PendingOrders = styled(TextBase)`
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[1]};
`;

export const ApprovedOrders = styled(TextBase)`
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.green.default};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  overflow: hidden;
  height: 58px;
  padding: 10px 12px;
  box-sizing: border-box;
`;
